const europeanUnionCountryAlpha3Codes = new Set([
  'AUT',
  'BEL',
  'BGR',
  'HRV',
  'CYP',
  'CZE',
  'DNK',
  'EST',
  'FIN',
  'FRA',
  'DEU',
  'GRC',
  'HUN',
  'IRL',
  'ITA',
  'LVA',
  'LTU',
  'LUX',
  'MLT',
  'NLD',
  'POL',
  'PRT',
  'ROU',
  'SVK',
  'SVN',
  'ESP',
  'SWE',
]);

export function isEuropeanUnionCountry(alpha3: string | null | undefined): boolean {
  return typeof alpha3 === 'string' && europeanUnionCountryAlpha3Codes.has(alpha3.trim().toUpperCase());
}
